/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IHeroTokensVault,
  IHeroTokensVaultInterface,
} from "../IHeroTokensVault";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
    ],
    name: "process",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IHeroTokensVault__factory {
  static readonly abi = _abi;
  static createInterface(): IHeroTokensVaultInterface {
    return new Interface(_abi) as IHeroTokensVaultInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IHeroTokensVault {
    return new Contract(address, _abi, runner) as unknown as IHeroTokensVault;
  }
}
